import React, { memo } from 'react'
import { Box, useTheme } from '@mui/material'

import poweredByBlack from 'src/assets/powered-by-black.png'
import poweredByWhite from 'src/assets/powered-by-white.png'
import { THEME_MODE } from '../../../libs/qb-brand-web-components'

const PoweredBy = () => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        mb: 1.25,
        mt: 1.25
      }}
    >
      <img
        alt='Powered by qiibee'
        src={
          theme.palette.mode === THEME_MODE.DARK
            ? poweredByWhite
            : poweredByBlack
        }
        style={{ height: 28 }}
      />
    </Box>
  )
}

export default memo(PoweredBy)
